{
    "smartTasks": {
        "tourLabel": "Compiti intelligenti",
        "learn": "Scopri come generare, riscrivere e tradurre testi con Cephable.",
        "generate": {
            "openTool": {
                "title": "Apri lo strumento Genera testo",
                "description": "Nel pannello Cephable, fare clic sull'icona accanto a Attività intelligenti e selezionare Genera testo."
            },
            "enterPrompt": {
                "title": "Inserisci richiesta",
                "description": "Nella casella di richiesta, digita: Crea un gioco di parole credibile in una sola frase."
            },
            "clickGenerate": {
                "title": "Fai clic su Genera",
                "description": "Fai clic sul pulsante Genera. Guarda il testo apparire in tempo reale."
            },
            "focusApp": {
                "title": "Concentrati sull'app",
                "description": "Assicurati di concentrarti sull'app in cui desideri che appaia il testo generato. Potrai generare il testo in modo fluido in quella posizione cliccando su Genera."
            }
        },
        "rewrite": {
            "welcome": {
                "title": "Benvenuti a Rewrite",
                "description": "Riformula rapidamente il contenuto evidenziando o incollando il testo."
            },
            "highlightToggle": {
                "title": "Usa testo evidenziato",
                "description": "Assicurati che sia selezionata l'opzione \"Usa testo evidenziato\" (impostazione predefinita)."
            },
            "highlightText": {
                "title": "Evidenzia il testo da riscrivere",
                "description": "In evidenza: un polipo può controllare ogni braccio in modo indipendente."
            },
            "enterInstructions": {
                "title": "Inserisci le istruzioni di riscrittura",
                "description": "Tipo: in stile inglese antico."
            },
            "clickGenerate": {
                "title": "Fai clic su Genera",
                "description": "Il testo evidenziato verrà riscritto in base ai tuoi input."
            },
            "pasteMode": {
                "title": "Usa Incolla testo",
                "description": "Incolla l'originale e riscrivi le istruzioni. Fai clic su Genera. Fai clic su Cancella per reimpostare."
            },
            "openTool": {
                "title": "Apri lo strumento Riscrivi testo",
                "description": "Nel pannello Cephable, fare clic sulla carota accanto a Attività intelligenti e selezionare Riscrivi testo."
            },
            "focusApp": {
                "title": "Concentrati sull'app",
                "description": "Assicurati di concentrarti sull'app in cui desideri che appaia il testo riscritto. Potrai generare il testo in quella posizione senza problemi cliccando su \"Genera\"."
            }
        },
        "translate": {
            "welcome": {
                "title": "Benvenuti a Translate",
                "description": "Traduci il testo evidenziato o incollato in un'altra lingua."
            },
            "highlightToggle": {
                "title": "Usa testo evidenziato",
                "description": "Assicurati che sia selezionata l'opzione \"Usa testo evidenziato\"."
            },
            "highlightText": {
                "title": "Evidenzia il testo da tradurre",
                "description": "In evidenza: un polipo può controllare ogni braccio in modo indipendente."
            },
            "enterLanguage": {
                "title": "Inserisci la lingua di destinazione",
                "description": "Tipo: portoghese."
            },
            "clickGenerate": {
                "title": "Fai clic su Genera",
                "description": "La traduzione verrà digitata nell'app in corrispondenza del cursore."
            },
            "pasteMode": {
                "title": "Usa Incolla testo",
                "description": "Incolla testo e lingua. Fai clic su Genera. Fai clic su Cancella per reimpostare."
            },
            "openTool": {
                "title": "Apri lo strumento Traduci testo",
                "description": "Nel pannello Cephable, fare clic sulla carota accanto a Attività intelligenti e selezionare Traduci testo."
            }
        },
        "rowDescription": "Le attività intelligenti sono le diverse attività che l'intelligenza artificiale di Cephable può svolgere per te. Queste attività sono basate sull'intelligenza artificiale integrata nel dispositivo e possono essere utilizzate per creare testi, riassumere, riscrivere, tradurre e altro ancora."
    },
    "overview": {
        "title": "Panoramica",
        "description": "Cephable è la tua intelligenza artificiale personale, progettata per azioni rapide, comandi vocali, generazione di contenuti e automazione intelligente su tutti i tuoi strumenti. Controlli pronti all'uso. Nessuna elaborazione cloud. Solo produttività che si muove con te."
    },
    "customControls": {
        "tourLabel": "Controlli globali e dei dispositivi sempre disponibili",
        "rowDescription": "I controlli globali e del dispositivo sono sempre disponibili se il microfono è attivo, indipendentemente dall'app utilizzata. Puoi utilizzare questi controlli per interagire con il dispositivo senza dover creare nuovi controlli per le app. Contengono comandi utili come lo scambio di controlli o app, la generazione di testo, la messa in pausa del microfono e altro ancora."
    },
    "profile": {
        "tourLabel": "Controlli dell'app",
        "learn": "Scopri come impostare i controlli e le preferenze delle tue app in Cephable.",
        "rowDescription": "I controlli delle app sono set di controlli configurati che puoi utilizzare per realizzare diverse azioni. Vuoi dire \"Diapositiva successiva\" per passare alla diapositiva successiva della presentazione? O usare i movimenti della testa per muovere il cursore e i comandi vocali per modificare le scorciatoie? Puoi farlo con i controlli delle app. La riga dei controlli mostra tutti i controlli disponibili per l'app corrente.",
        "check": {
            "title": "Controlla i controlli disponibili.",
            "description": "I controlli app sono disponibili per ogni app che utilizzi. Qui puoi vedere i controlli disponibili per l'app che stai utilizzando. Prova un altro comando per vedere come funziona. Assicurati però di concentrarti sull'app che desideri controllare."
        }
    },
    "dictation": {
        "tourLabel": "Dettatura",
        "learn": "Scopri come usare la modalità dettatura per convertire i tuoi discorsi in testo senza usare le mani.",
        "welcome": {
            "title": "Dettatura",
            "description": "La dettatura ti permette di parlare in modo naturale e di sentire le parole digitate mentre parli. È come avere un assistente personale che digita tutto quello che dici."
        },
        "microphone": {
            "title": "Accendi il microfono",
            "description": "Per prima cosa, accendi il microfono. Fai clic sull'interruttore del microfono nel pannello Cephable."
        },
        "activate": {
            "title": "Avvia la modalità di dettatura",
            "description": "La voce si avvia in modalità comando. Per avviare la dettatura, pronuncia \"Avvia dettatura\" o fai clic sul pulsante Dettatura. Attiviamo ora la modalità dettatura."
        },
        "focus": {
            "title": "Concentrati su un campo di testo o un documento",
            "description": "La dettatura funziona meglio quando ci si concentra su un campo di testo o un documento. Fare clic sul campo di testo o sul documento in cui si desidera dettare."
        },
        "speaking": {
            "title": "Inizia a parlare",
            "description": "Ora puoi iniziare a parlare. Tutto ciò che dici verrà digitato nel campo di testo o nel documento su cui ti sei concentrato. Prova a dire qualcosa come \"Ciao, questo è un test della modalità dettatura\"."
        },
        "pauseResume": {
            "title": "Mettere in pausa la dettatura",
            "description": "Hai bisogno di una pausa senza disattivare la dettatura? Basta dire \"Metti in pausa la dettatura\". Puoi riprendere la dettatura in qualsiasi momento premendo di nuovo \"Avvia dettatura\". Puoi personalizzare ulteriormente questa impostazione con i controlli globali e del dispositivo sempre attivi."
        },
        "stop": {
            "title": "Interruzione della dettatura",
            "description": "Devi tornare ai controlli dell'app? Basta dire \"Interrompi dettatura\". Questo interromperà la modalità dettatura e ti riporterà alla modalità comando. Puoi riprendere in qualsiasi momento premendo nuovamente \"Avvia dettatura\"."
        },
        "complete": {
            "description": "Ecco fatto! Ora puoi dettare, mettere in pausa, riprendere e passare dalla modalità dettatura a quella di comando. La dettatura è un potente strumento per la digitazione a mani libere. Usala per scrivere email, documenti o qualsiasi altra cosa tu debba digitare ad alta voce."
        }
    },
    "camera": {
        "tourLabel": "Controlli della fotocamera",
        "rowDescription": "I controlli della fotocamera ti consentono di usare il viso e il corpo per controllare il dispositivo. Puoi usare diverse espressioni facciali e movimenti della testa per controllare il dispositivo. Con il microfono attivo, puoi usare i comandi vocali per avviare e arrestare la fotocamera e cambiare fotocamera.",
        "learn": "Scopri come usare i comandi della fotocamera per navigare e interagire con il tuo dispositivo senza usare le mani.",
        "welcome": {
            "title": "Controlli della fotocamera",
            "description": "I controlli della fotocamera ti consentono di usare il viso e il corpo per controllare il dispositivo. Puoi usare diverse espressioni facciali, movimenti della testa e comandi vocali per navigare e interagire con il dispositivo a mani libere."
        },
        "start": {
            "title": "Avvia i controlli della fotocamera",
            "description": "Per iniziare a usare i controlli della telecamera se stai usando la voce, pronuncia \"Avvia controlli della telecamera\" o fai clic sul pulsante Controlli della telecamera."
        }
    },
    "microphone": {
        "tourLabel": "Comandi vocali",
        "learn": "Scopri come usare la voce per controllare qualsiasi app e come usare la dettatura per scrivere ciò che dici.",
        "description": "I controlli vocali Cephable ti permettono di usare la voce per controllare il tuo dispositivo. Vuoi salvare un documento? Di' semplicemente \"Salva\". Vuoi mettere in pausa la musica? Di' semplicemente \"Pausa\". La voce ti permette anche di usare la dettatura per digitare ciò che dici.",
        "rowDescription": "Quando il microfono è disattivato, non ascolteremo affatto i tuoi comandi vocali, ma se lo attivi, potrai usare i comandi globali per attivare/disattivare pausa, avvio e altro ancora. Attiviamolo.",
        "start": {
            "title": "Avvia i controlli vocali",
            "description": "Per iniziare a utilizzare i comandi vocali, fai clic sull'interruttore del microfono nel pannello Cephable. In questo modo, il microfono verrà attivato e inizierà ad ascoltare i comandi."
        },
        "tryOpen": {
            "title": "Prova a dire `Apri Spotify` o `Apri Word`",
            "description": "`Apri` è un comando globale che aprirà l'app specificata e le assegnerà il focus. Se hai abilitato il cambio automatico dei controlli, passerà anche ai controlli dell'app che meglio si adattano all'app che stai utilizzando."
        },
        "finishedCommands": {
            "title": "Ottimo! Hai imparato le basi dei comandi vocali.",
            "description": "Puoi sempre rivedere il tour dalla pagina di supporto. Il passo successivo è imparare a usare la dettatura. Puoi avviare il tour dalla pagina di supporto."
        }
    },
    "publicProfiles": {
        "tourLabel": "Personalizza i controlli dell'app"
    },
    "tour": {
        "title": "Benvenuti a Cephable",
        "description": "Cephable è un potente strumento che ti permette di controllare il tuo computer tramite voce, fotocamera e altri input. Questo tutorial ti guiderà attraverso le funzionalità principali e ti mostrerà come utilizzarle al meglio.",
        "startTour": "Inizia il tour",
        "finishTour": "Fine del tour",
        "statusDialog": "Per maggiori informazioni consultare il pannello.",
        "step": "Passo {{step}} di {{total}}",
        "next": "Prossimo",
        "previous": "Precedente",
        "endTour": "Fine del tour",
        "nextTourLabel": "Successivo: {{nextStepTitle}}",
        "skipTour": "Salta il tour",
        "steps": {
            "welcome": {
                "title": "Benvenuti a Cephable",
                "description": "Questo tour ti guiderà attraverso le funzionalità principali di Cephable. Iniziamo!"
            },
            "inputs": {
                "title": "Panoramica degli input",
                "description": "Cephable supporta diversi metodi di input, inclusi comandi vocali, controlli della fotocamera e altro ancora. È possibile personalizzare questi input nelle impostazioni."
            },
            "appControls": {
                "title": "Controlli dell'app",
                "description": "Crea controlli app per associare i tuoi input ad azioni specifiche nelle tue applicazioni. In questo modo puoi controllare le app con gesti, comandi vocali e altro ancora."
            },
            "settings": {
                "title": "Impostazioni",
                "description": "Accedi alle impostazioni per configurare gli input, i controlli delle app e altre preferenze. Puoi anche gestire le impostazioni del tuo account e della lingua."
            },
            "intelligentTasks": {
                "title": "Compiti intelligenti",
                "description": "Utilizza attività intelligenti per generare testo, riassumere contenuti, riscrivere testi, tradurre lingue e altro ancora utilizzando funzionalità basate sull'intelligenza artificiale."
            },
            "cameraControls": {
                "title": "Controlli della fotocamera",
                "description": "Abilita i controlli della telecamera per utilizzare le espressioni facciali e i movimenti della testa come metodi di input per controllare il computer."
            },
            "voiceControls": {
                "title": "Comandi vocali",
                "description": "Usa i comandi vocali per controllare il tuo computer senza usare le mani. Puoi dettare testo, impartire comandi e interagire con le applicazioni usando la voce."
            }
        }
    },
    "onboarding": {
        "demoPlaceholder": "Questo è il testo demo segnaposto. Utilizzando i prompt qui sopra puoi controllare lo stile di questo testo.",
        "exit": "Esci dalla configurazione",
        "overview": "Panoramica",
        "learn": "Scopri le funzionalità di Cephable e come utilizzarle.",
        "start": "Sembra che tu abbia appena iniziato. Ecco alcuni aspetti che ti aiuteranno lungo il percorso.",
        "startTour": "Per iniziare",
        "dashboard": {
            "title": "Dashboard Cephable",
            "description": "La dashboard di Cephable è il tuo hub centrale per la gestione del dispositivo, dei controlli delle app e delle impostazioni. Da qui puoi personalizzare la tua esperienza, visualizzare i comandi attivi e accedere a tutte le funzionalità di Cephable."
        },
        "step1": {
            "title": "Benvenuti a Cephable",
            "description": "Cephable è la tua intelligenza artificiale personale, progettata per azioni rapide, comandi vocali, generazione di contenuti e automazione intelligente su tutti i tuoi strumenti. Controlli pronti all'uso. Nessuna elaborazione cloud. Solo produttività che si muove con te.",
            "inputs": "Cosa sono gli input?",
            "inputDescription": "I controlli di input sono i metodi per utilizzare il dispositivo, estendendo le capacità del computer oltre i tradizionali mouse e tastiera. Questi metodi includono comandi vocali, movimenti della testa, espressioni facciali e periferiche aggiuntive.",
            "profiles": "Cosa sono i controlli delle app?",
            "profileDescription": "I controlli app ti consentono di connetterti e comunicare con il tuo computer in modi unici, abbinando controlli di input e output. Con i controlli app, puoi chiedere a Cephable di eseguire azioni come salvare un file inclinando la testa o cliccare su \"Invia\" su un'e-mail con un sorriso.",
            "action": "Esplora i controlli di input",
            "secondaryAction": "Vai ai controlli dell'app",
            "secondaryActionDescription": "Conosci già i controlli di input?"
        },
        "finish": {
            "title": "Configurazione completata",
            "description": "Hai utilizzato con successo i tuoi primi controlli app Cephable! Ora puoi utilizzarli e molto altro sul tuo dispositivo. Sono disponibili nella dashboard di Cephable, dove puoi continuare a personalizzare le impostazioni dei controlli app in base alle tue esigenze.",
            "continueToApp": "Continua alla dashboard di Cephable",
            "keepExploring": "Continua a esplorare"
        },
        "useCaseSlider": {
            "context": "Vorrei usare",
            "control": "controllare"
        }
    },
    "support": {
        "tourLabel": "Pronti a saperne di più?",
        "description": "Per maggiori informazioni su come utilizzare Cephable, tra cui ulteriori tour, guide dettagliate, tutorial e video, puoi visitare il nostro hub di supporto.",
        "cta": "Esplora altri tour"
    },
    "featureFlag": {
        "title": "È ora di aggiornare",
        "description": "La funzionalità che stai tentando di utilizzare richiede una licenza diversa. Esegui l'upgrade per sbloccare questa e altre funzionalità."
    },
    "replyToSocialMedia": {
        "tourLabel": "Risposte più rapide sui social media con la dettatura",
        "learn": "Scopri come usare la dettatura per rispondere ai post sui social media senza usare le mani.",
        "navigateTo": {
            "title": "Vai a un post sui social media",
            "description": "Apri il tuo browser web e accedi a una piattaforma social come LinkedIn o Facebook. Trova un post a cui vuoi rispondere."
        },
        "speaking": {
            "title": "Inizia a parlare",
            "description": "Ora puoi iniziare a parlare. Tutto ciò che dirai verrà digitato nel campo di testo o nel documento su cui ti sei concentrato. Prova a dire qualcosa come \"Congratulazioni! Sono emozionato per te\". Assicurati che il cursore sia posizionato su un campo di testo o una casella di commento."
        },
        "complete": {
            "description": "Ecco fatto! Ora puoi usare le funzioni di dettatura, pausa, ripresa e alternare tra dettatura e comando per rispondere ai post sui social media senza usare le mani. La dettatura è uno strumento potente per la digitazione a mani libere. Usala per scrivere email, documenti o qualsiasi altra cosa tu debba digitare ad alta voce."
        }
    },
    "hotkeys": {
        "tourLabel": "Pulsanti di azione rapida",
        "learn": "Scopri come impostare pulsanti di azione rapida per associare più azioni a un singolo pulsante.",
        "rowDescription": "I pulsanti di azione rapida consentono di eseguire più azioni con un singolo comando. Ad esempio, puoi creare un pulsante che apre la tua app musicale preferita e avvia la riproduzione di una playlist specifica.",
        "check": {
            "title": "Controlla le azioni rapide disponibili.",
            "description": "I pulsanti di azione rapida sono disponibili per ogni app che utilizzi. Qui puoi vedere i pulsanti disponibili per l'app che stai utilizzando. Prova un altro comando per vedere come funziona. MA assicurati di concentrarti sull'app che desideri controllare."
        }
    },
    "controllingBackgroundMusic": {
        "tourLabel": "Gestisci la musica di sottofondo senza interrompere il tuo flusso",
        "learn": "Scopri come utilizzare i comandi vocali e le azioni rapide per gestire la tua musica a mani libere, senza distrarti e concentrandoti sul tuo compito.",
        "tryOpen": {
            "title": "Prova a dire `Apri Spotify` o `Apri Apple Music`"
        },
        "play": {
            "title": "Prova a dire `Riproduci` per iniziare a riprodurre la musica",
            "description": "Assicurati che il microfono sia acceso e pronuncia il comando `Riproduci`. In questo modo verrà avviata la riproduzione della musica nell'app musicale scelta. Questo funziona anche per qualsiasi altra app multimediale."
        },
        "newPlaylist": {
            "title": "Crea una nuova playlist",
            "description": "Assicurati che il microfono sia acceso e pronuncia \"Nuova playlist\". Questo avvierà il processo di creazione di una nuova playlist nell'app musicale scelta."
        },
        "finishedCommands": {
            "title": "Ottimo lavoro! Hai imparato a controllare la tua musica senza usare le mani.",
            "description": "Ora sai come utilizzare i comandi vocali e le azioni rapide per riprodurre, mettere in pausa, saltare le tracce e regolare il volume nelle tue app musicali preferite. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un controllo musicale ancora più fluido."
        }
    },
    "editingVideos": {
        "tourLabel": "Concentrati sulla storia, non sui noiosi clic per il montaggio video",
        "learn": "Scopri come utilizzare i comandi vocali e le azioni rapide per modificare i video più velocemente ed eliminare il carico cognitivo di dover ricordare quali pulsanti cliccare durante la modifica.",
        "tryOpen": {
            "title": "Prova a dire `Apri iMovie` o `Apri DaVinci Resolve`"
        },
        "play": {
            "title": "Prova a dire `Riproduci` per iniziare a riprodurre il tuo video",
            "description": "Assicurati che il microfono sia acceso e pronuncia `Riproduci`. In questo modo verrà avviata la riproduzione del video nell'app di editing video scelta."
        },
        "stop": {
            "title": "Interrompi la riproduzione video",
            "description": "Assicurati che il microfono sia acceso e pronuncia `Stop`. Questo interromperà la riproduzione del video nell'app di editing video che hai scelto."
        },
        "finishedCommands": {
            "title": "Ottimo lavoro! Hai imparato a controllare il tuo video editing senza usare le mani.",
            "description": "Ora sai come utilizzare i comandi vocali e le azioni rapide per riprodurre, mettere in pausa, saltare tracce e regolare il volume nelle tue app di editing video preferite. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un controllo video ancora più fluido."
        }
    },
    "vibeCoding": {
        "tourLabel": "Ideare, prototipare e ripetere più velocemente con la dettatura",
        "learn": "Scopri come utilizzare la dettatura e la generazione di testo basata sull'intelligenza artificiale per dare ritmo al codice, creare prototipi e ripetere le idee.",
        "navigateTo": {
            "title": "Passare a un editor di codice Vibe",
            "description": "Apri il tuo browser web e accedi a un editor di codice Vibe. Alcuni esempi sono Vercel V0, GitHub Copilot in VS Code, Base 44 e Lovable."
        },
        "focus": {
            "title": "Fai clic su Nuova chat o seleziona una casella di testo",
            "description": "La dettatura funziona meglio quando ci si concentra su un campo di testo o un documento. Fare clic sulla casella dei commenti o sul thread di risposta in cui si desidera dettare. Quindi iniziare a parlare."
        },
        "speaking": {
            "title": "Inizia a parlare",
            "description": "Ora puoi iniziare a parlare. Tutto ciò che dirai verrà digitato nel campo di testo o nel documento su cui ti sei concentrato. Prova a specificare i tuoi requisiti tecnici e cosa dovrebbe fare il codice. Assicurati che il cursore sia posizionato su un campo di testo o una casella di commento."
        },
        "rewriteIntro": {
            "title": "Riscrivi il codice con le istruzioni",
            "description": "Puoi anche utilizzare le attività intelligenti come Rewrite per modificare il codice esistente. Questa attività è basata sull'intelligenza artificiale integrata nel dispositivo, il che significa che funziona anche senza connessione a Internet ed è eseguibile direttamente dal tuo dispositivo."
        },
        "highlightText": {
            "title": "Evidenzia il testo da riscrivere",
            "description": "Evidenzia il codice che vuoi riscrivere."
        },
        "enterInstructions": {
            "title": "Inserisci le istruzioni di riscrittura",
            "description": "Digita le istruzioni di riscrittura del codice. Specifica il linguaggio di programmazione, lo stile o eventuali modifiche specifiche che desideri."
        },
        "complete": {
            "description": "Ecco fatto! Ora puoi dettare, mettere in pausa, riprendere e iterare sul codice. Continua a esplorare altri casi d'uso con Dettatura e Attività intelligenti, o altre funzionalità per ottimizzare il tuo flusso di lavoro."
        }
    },
    "documentCode": {
        "tourLabel": "Documentazione del codice rapida e sicura con generazione di testo AI sul dispositivo",
        "learn": "Scopri come utilizzare la riscrittura basata sull'intelligenza artificiale per documentare il codice, rimanendo nella stessa app e mantenendo i tuoi dati al sicuro.",
        "rewriteIntro": {
            "title": "Scrivi la documentazione del codice",
            "description": "È possibile utilizzare Cephable Intelligent Rewrite per scrivere la documentazione del codice in un documento o in un'app separata. La riscrittura fa parte delle attività di intelligenza artificiale sul dispositivo, tra cui Generazione e Traduzione offline."
        },
        "focusApp": {
            "title": "Concentrati sul tuo codice",
            "description": "Apri l'IDE e concentrati sul codice che vuoi documentare."
        },
        "newFile": {
            "title": "Creare un file di documentazione",
            "description": "Crea un nuovo file nel tuo IDE oppure apri un'app separata in cui desideri che venga visualizzata la documentazione."
        },
        "highlightText": {
            "title": "Evidenzia il codice",
            "description": "Evidenzia e copia il codice che vuoi documentare."
        },
        "pasteMode": {
            "title": "Fare clic sulla scheda Incolla testo",
            "description": "Utilizzare la modalità Incolla per incollare il codice originale e scrivere la documentazione in un nuovo file."
        },
        "pasteInput": {
            "title": "Incolla il codice nel documento",
            "description": "Incolla il codice che vuoi documentare nella casella di input."
        },
        "enterInstructions": {
            "title": "Inserisci le istruzioni di formattazione, stile e contenuto",
            "description": "Digita le istruzioni per la documentazione del codice. Specifica il tipo di file (ad esempio markdown), lo stile o qualsiasi contenuto specifico desideri."
        },
        "complete": {
            "description": "Hai imparato a utilizzare le Attività Intelligenti per una documentazione del codice rapida e sicura. Continua a esplorare altri casi d'uso con Rewrite o altre funzionalità per ottimizzare il tuo flusso di lavoro."
        }
    },
    "generateCode": {
        "tourLabel": "Generazione di codice rapida e sicura con generazione di testo AI sul dispositivo",
        "learn": "Scopri come utilizzare la generazione basata sull'intelligenza artificiale per creare frammenti di codice durante lo spostamento tra le app e mantenendo i tuoi dati al sicuro.",
        "rewriteIntro": {
            "title": "Scrivi frammenti di codice",
            "description": "Puoi utilizzare Cephable Intelligent Rewrite per scrivere frammenti di codice nel tuo IDE mentre ottieni requisiti da un'altra applicazione. Rewrite fa parte delle attività di intelligenza artificiale sul dispositivo, tra cui Generazione e Traduzione offline."
        },
        "focusApp": {
            "title": "Concentrati sul contenuto del tuo biglietto",
            "description": "Apri il ticket che specifica i requisiti e concentrati sul contenuto per cui vuoi generare il codice."
        },
        "newFile": {
            "title": "Creare un file di frammenti di codice",
            "description": "Crea un nuovo file nel tuo IDE."
        },
        "highlightText": {
            "title": "Evidenzia il contenuto del biglietto",
            "description": "Evidenzia e copia il contenuto per cui vuoi generare il codice."
        },
        "pasteMode": {
            "title": "Fare clic sulla scheda Incolla testo",
            "description": "Utilizzare la modalità Incolla per incollare i requisiti del biglietto originale e scrivere frammenti di codice per essi."
        },
        "pasteInput": {
            "title": "Incolla i requisiti per generare il codice",
            "description": "Incolla nella casella di input i requisiti che desideri utilizzare per la generazione del codice."
        },
        "enterInstructions": {
            "title": "Inserisci le istruzioni del linguaggio e dello stile di programmazione",
            "description": "Digita le istruzioni per il linguaggio di programmazione e lo stile. Specifica il linguaggio di programmazione (ad esempio C#), lo stile o eventuali istruzioni di codifica specifiche di cui disponi."
        },
        "translateIntro": {
            "title": "Traduci frammenti di codice",
            "description": "Puoi anche utilizzare Cephable Intelligent Translate per convertire frammenti di codice da un linguaggio di programmazione a un altro direttamente nel tuo IDE. Translate fa parte delle attività di intelligenza artificiale sul dispositivo, tra cui Generazione e riscrittura offline."
        },
        "copyGeneratedCode": {
            "title": "Copia il codice generato",
            "description": "Dopo aver generato il codice seguendo i passaggi precedenti, evidenzia e copia il frammento di codice generato."
        },
        "translatePasteMode": {
            "title": "Fare clic sulla scheda Incolla testo",
            "description": "Utilizzare la modalità Incolla per incollare il codice originale e tradurlo in un altro linguaggio di programmazione."
        },
        "enterProgrammingLanguage": {
            "title": "Inserisci il linguaggio di programmazione di destinazione",
            "description": "Digita il linguaggio di programmazione in cui vuoi tradurre il codice (ad esempio Python)."
        },
        "pasteCode": {
            "title": "Incolla il codice generato nel tuo IDE",
            "description": "Vai all'IDE e incolla il frammento di codice copiato nel nuovo file creato in precedenza."
        },
        "complete": {
            "description": "Hai imparato a utilizzare le Attività Intelligenti per generare e tradurre codice in modo rapido e sicuro. Continua a esplorare altri casi d'uso con Genera e Traduci, o altre funzionalità per ottimizzare il tuo flusso di lavoro."
        }
    },
    "requirementDocsFromMeeting": {
        "tourLabel": "Dalle note ai documenti sui requisiti del prodotto in pochi minuti",
        "learn": "Scopri come utilizzare le attività intelligenti dell'intelligenza artificiale per creare documenti strutturati sui requisiti di prodotto a partire dagli appunti delle riunioni, mantenendo al contempo la sicurezza dei tuoi dati.",
        "rewriteIntro": {
            "title": "Creare documenti sui requisiti del prodotto",
            "description": "È possibile utilizzare Cephable Intelligent Rewrite per creare documenti strutturati sui requisiti di prodotto a partire dagli appunti delle riunioni. Rewrite fa parte delle attività di intelligenza artificiale sul dispositivo, tra cui Generazione e Traduzione offline."
        },
        "focusNotes": {
            "title": "Apri le note della riunione",
            "description": "Apri gli appunti della riunione, le trascrizioni o altri contenuti di testo correlati alla riunione."
        },
        "highlight": {
            "title": "Evidenziare gli appunti della riunione",
            "description": "Evidenzia gli appunti della riunione che vuoi utilizzare per creare un documento sui requisiti del prodotto."
        },
        "enterInstructions": {
            "title": "Inserisci la struttura del documento e le istruzioni sul contenuto",
            "description": "Digita le istruzioni del documento sui requisiti del prodotto. Specifica la struttura, lo stile o qualsiasi contenuto specifico desideri."
        },
        "complete": {
            "description": "Hai imparato a utilizzare le Attività Intelligenti per creare documenti sui requisiti di prodotto in modo rapido e sicuro. Continua a esplorare altri casi d'uso con Rewrite o altre funzionalità per ottimizzare il tuo flusso di lavoro."
        }
    },
    "headMouseMovement": {
        "tourLabel": "Configurazione di gioco a mani libere con Head Mouse",
        "learn": "Scopri come usare i movimenti della testa per controllare il cursore del mouse e ottenere una navigazione e un clic precisi.",
        "deviceSettings": {
            "title": "Apri Impostazioni dispositivo",
            "description": "Per abilitare i movimenti del mouse tramite la testa, fare clic sul pulsante Impostazioni dispositivo."
        },
        "cameraSettings": {
            "title": "Apri le impostazioni della fotocamera",
            "description": "Nelle Impostazioni dispositivo, fare clic su Impostazioni fotocamera per accedere ai controlli della fotocamera."
        },
        "headMouseSection": {
            "title": "Movimento della testa per i controlli del mouse",
            "description": "Quando questa opzione è attivata, alcuni dei controlli per il movimento della testa verranno utilizzati per muovere il mouse anziché i controlli di attivazione."
        },
        "steadyGlide": {
            "title": "Modalità di planata costante",
            "description": "Attiva la modalità Steady Glide. Quando muovi la testa oltre un certo punto, il cursore scivola continuamente in quella direzione a velocità costante."
        },
        "customization": {
            "title": "Personalizza le impostazioni del mouse sulla testa",
            "description": "Puoi personalizzare le impostazioni del mouse in base alle tue preferenze. Regola velocità, sensibilità e altre impostazioni per ottenere la migliore esperienza."
        },
        "save": {
            "title": "Salva le impostazioni del mouse sulla testa",
            "description": "Non dimenticare di salvare le impostazioni personalizzate del mouse."
        },
        "transition": {
            "title": "Passaggio al pannello Cephable",
            "description": "Passiamo ora al pannello Cephable per provare i movimenti della testa del mouse."
        },
        "playGames": {
            "title": "Gioca con il mouse sulla testa",
            "description": "Ora puoi usare i movimenti della testa per controllare il cursore del mouse mentre giochi. Provalo e scopri come funziona!"
        }
    },
    "clinicalNoteTaking": {
        "tourLabel": "Dettatura e formattazione conformi all'HIPAA per i medici",
        "learn": "Scopri come utilizzare i comandi vocali, la dettatura intelligente e la formattazione basata sull'intelligenza artificiale per prendere appunti clinici.",
        "speaking": {
            "title": "Inizia a parlare",
            "description": "Ora puoi iniziare a parlare. Tutto ciò che dirai verrà digitato nel campo di testo o nel documento su cui ti sei concentrato. Prova a dire qualcosa come: \"Il paziente è un uomo di 45 anni con una storia di ipertensione. L'ultimo farmaco prescritto non ha funzionato come previsto e ha causato una reazione allergica. Dovremo verificare la presenza di farmaci alternativi e vorrebbero una prescrizione di un farmaco generico\"."
        },
        "rewriteIntro": {
            "title": "Formatta le tue note",
            "description": "Ora puoi usare Cephable Intelligent Rewrite per formattare le tue note in stile SOAP. Tutto questo avviene direttamente sul dispositivo, il che significa che i tuoi dati rimangono privati, sicuri e conformi allo standard HIPAA."
        },
        "copyText": {
            "title": "Copia le note",
            "description": "Dopo aver evidenziato le note, copia il testo per prepararlo alla formattazione."
        },
        "pasteMode": {
            "title": "Fare clic sulla scheda Incolla testo",
            "description": "Utilizzare la modalità Incolla per incollare le note originali e formattarle in stile SOAP."
        },
        "pasteInput": {
            "title": "Incolla le note nel formato",
            "description": "Incolla le note che vuoi formattare nella casella di input."
        },
        "enterInstructions": {
            "title": "Inserisci le istruzioni di formattazione",
            "description": "Puoi scrivere istruzioni di formattazione che dovranno essere seguite per il tuo sistema clinico/EHR. (Ad esempio, formatta in stile SOAP con titoli, punti elenco e linguaggio conciso.)"
        },
        "navigateToEHR": {
            "title": "Accedi al tuo sistema EHR",
            "description": "Apri il tuo sistema EHR e vai alla sezione in cui desideri inserire le note formattate."
        },
        "focusTextField": {
            "title": "Concentrati sul campo di testo",
            "description": "Fare clic sul campo di testo in cui si desidera incollare le note formattate."
        },
        "complete": {
            "description": "Hai imparato a utilizzare i comandi vocali e la dettatura intelligente per documentare le note cliniche, e la riscrittura intelligente per formattarle in stile SOAP. Continua a esplorare altri casi d'uso con la dettatura e la riscrittura, o altre funzionalità per ottimizzare il tuo flusso di lavoro."
        },
        "focus": {
            "title": "Concentrati su un documento",
            "description": "La dettatura funziona meglio quando ci si concentra su un documento. Apri un documento in cui vuoi prendere appunti clinici tra una sessione e l'altra."
        }
    },
    "webBrowsing": {
        "tourLabel": "Pianifica viaggi, fai acquisti online e naviga sul Web utilizzando la voce",
        "learn": "Scopri come usare i comandi vocali per navigare, scorrere e compilare moduli mentre navighi sul Web senza usare le mani.",
        "tryOpen": {
            "title": "Prova a dire `Apri Chrome` o `Apri Edge`",
            "description": "Assicurati che il microfono sia attivo e pronuncia \"Apri Chrome\" o \"Apri Edge\". Verrà aperto il browser web scelto. Se hai attivato il cambio automatico dei controlli, verranno utilizzati anche i controlli dell'app più adatti all'app che stai utilizzando."
        },
        "search": {
            "title": "Ricerca",
            "description": "Prova a dire \"Cerca\" o \"Cerca\". In questo modo verrà focalizzata la barra di ricerca nel tuo browser."
        },
        "quickType": {
            "title": "Digitazione rapida",
            "description": "La Digitazione Rapida ti consente di digitare usando la voce senza essere in modalità dettatura. Prova a dire \"Scrivi che tempo fa oggi\". In questo modo, la tua query verrà digitata nella barra di ricerca."
        },
        "enter": {
            "title": "Premi Invio",
            "description": "Prova a dire \"Invio\". Verrà eseguita la query di ricerca appena digitata."
        },
        "scrollDown": {
            "title": "Scorrere verso il basso",
            "description": "Prova a dire \"Scorri verso il basso\". In questo modo la pagina web scorrerà verso il basso."
        },
        "scrollUp": {
            "title": "Scorri verso l'alto",
            "description": "Prova a dire \"Scorri verso l'alto\". In questo modo la pagina web scorrerà verso l'alto."
        },
        "newTab": {
            "title": "Apri una nuova scheda",
            "description": "Prova a dire \"Nuova scheda\". Si aprirà una nuova scheda nel tuo browser."
        },
        "formsCustomization": {
            "title": "Personalizzazione della compilazione dei moduli",
            "description": "Puoi personalizzare i controlli di questa app per compilare facilmente i moduli, ad esempio inserendo nome, cognome, indirizzo email, ecc. Puoi anche usare le azioni rapide o i comandi vocali per compilare i moduli ancora più velocemente."
        },
        "complete": {
            "title": "Ottimo lavoro!",
            "description": "Ora sai come utilizzare i comandi vocali e le azioni rapide per navigare, cercare, scorrere e compilare moduli mentre navighi sul web. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per una navigazione web ancora più fluida."
        }
    },
    "spreadsheetReviews": {
        "tourLabel": "Lavora più velocemente nei fogli di calcolo con i comandi vocali",
        "learn": "Scopri come utilizzare i comandi vocali e le azioni rapide per rivedere e modificare rapidamente fogli di calcolo di grandi dimensioni.",
        "tryOpen": {
            "title": "Prova a dire `Apri Excel` o `Apri Fogli Google`",
            "description": "Assicurati che il microfono sia acceso e pronuncia \"Apri Excel\" o \"Apri Fogli Google\". Verrà aperta l'app per fogli di calcolo scelta. Se hai attivato il cambio automatico dei controlli, verranno utilizzati anche i controlli più adatti all'app che stai utilizzando."
        },
        "selectRow": {
            "title": "Seleziona una riga",
            "description": "Fai clic su una cella. Quindi, prova a dire \"Seleziona riga\". In questo modo verrà selezionata l'intera riga della cella evidenziata."
        },
        "delete": {
            "title": "Elimina il contenuto di una riga",
            "description": "Prova a dire \"Elimina\". In questo modo eliminerai il contenuto della riga selezionata."
        },
        "note": {
            "title": "Aggiungi una nota a una cella",
            "description": "Fai clic su una cella. Quindi, prova a dire \"Aggiungi nota\". Questo ti permetterà di aggiungere una nota alla cella evidenziata."
        },
        "addNote": {
            "title": "Digita la nota",
            "description": "Prova a dire \"Digita Questi numeri non corrispondono\". In questo modo la nota verrà digitata nella cella."
        },
        "currentDate": {
            "title": "Inserisci la data corrente",
            "description": "Fai clic su una cella. Quindi, prova a dire \"Data corrente\". In questo modo, la data corrente verrà inserita nella cella evidenziata."
        },
        "copy": {
            "title": "Copia una cella",
            "description": "Fai clic sulla cella a cui hai appena aggiunto la data corrente. Quindi, prova a dire \"Copia\". In questo modo, la data corrente verrà copiata."
        },
        "selectColumn": {
            "title": "Seleziona una colonna",
            "description": "Prova a dire \"Colonna\". In questo modo verrà selezionata l'intera colonna per la cella evidenziata."
        },
        "paste": {
            "title": "Incolla la data corrente",
            "description": "Prova a dire \"Incolla\". In questo modo la data corrente verrà incollata nella colonna selezionata."
        },
        "quickActions": {
            "title": "Utilizzare le azioni rapide",
            "description": "Puoi anche eseguire molti di questi controlli e altro ancora con i pulsanti Azione rapida. Puoi personalizzare questi pulsanti per adattarli al tuo flusso di lavoro e rendere ancora più veloce la revisione e la modifica dei fogli di calcolo."
        },
        "complete": {
            "description": "Ora sai come utilizzare i comandi vocali e le azioni rapide per rivedere e modificare rapidamente fogli di calcolo di grandi dimensioni. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per una gestione più rapida dei fogli di calcolo."
        }
    },
    "socialMediaWriting": {
        "tourLabel": "Crea, ripeti e pubblica contenuti sui social media con la voce e l'intelligenza artificiale sul dispositivo",
        "learn": "Scopri come utilizzare Intelligent Generate and Rewrite, una funzionalità completamente privata e integrata nel dispositivo, per creare e modificare i contenuti.",
        "onDeviceIntro": {
            "title": "La tua ricerca rimane privata e sicura",
            "description": "Le attività intelligenti di Cephable sono basate sull'intelligenza artificiale integrata nel dispositivo, il che significa che i tuoi dati rimangono privati e al sicuro. Puoi creare, riscrivere e tradurre testi senza alcuna elaborazione cloud. Puoi anche utilizzare il contesto multi-applicazione e iterare sulle idee direttamente nella tua app preferita."
        },
        "enterPrompt": {
            "title": "Inizia a ideare",
            "description": "Nella casella di input, scrivi un prompt per il contenuto che desideri creare o generare. Ad esempio, puoi inserire: \"Elenca i rischi dell'intelligenza artificiale agentiva, dove si trovano alcune lacune e come l'innovazione può progredire\"."
        },
        "customizeSettings": {
            "title": "Personalizza le impostazioni di generazione",
            "description": "Puoi personalizzare le impostazioni di generazione in base alle tue preferenze. Regolale con i prompt di sistema che riflettono il tono, la voce del brand e altro ancora."
        },
        "rewriteIntro": {
            "title": "Ripetizione del contenuto",
            "description": "Puoi utilizzare Cephable Intelligent Rewrite per iterare i contenuti direttamente nella tua app preferita. Tutto questo avviene direttamente sul dispositivo, il che significa che i tuoi dati rimangono privati e al sicuro."
        },
        "highlightText": {
            "title": "Evidenzia il testo da riscrivere",
            "description": "Evidenzia uno dei rischi elencati nel contenuto generato su cui vuoi continuare a lavorare."
        },
        "enterInstructions": {
            "title": "Inserisci le istruzioni di riscrittura",
            "description": "Digita le istruzioni per la riscrittura. Ad esempio, puoi inserire: \"Aggiungi maggiori dettagli sui rischi\"."
        },
        "writeSocialMediaPost": {
            "title": "Scrivi un post sui social media",
            "description": "Utilizza nuovamente la riscrittura per riformattare questo linguaggio in un post sui social media rivolto al pubblico, che coglie i punti chiave e mette in evidenza le aree di coinvolgimento."
        },
        "highlightPost": {
            "title": "Evidenzia il post generato",
            "description": "Evidenzia il post generato sui social media che desideri utilizzare."
        },
        "enterPostInstructions": {
            "title": "Inserisci le istruzioni per la pubblicazione",
            "description": "Inserisci le istruzioni per il tuo post. Ad esempio, puoi scrivere: \"Rendilo conciso e accattivante per LinkedIn\"."
        },
        "complete": {
            "description": "Ora puoi aprire la tua piattaforma social preferita, concentrarti sulla casella di testo per la creazione del post e incollare il post generato. Oppure puoi continuare a iterare e perfezionare finché non sei pronto!"
        }
    },
    "inboxTriage": {
        "tourLabel": "Gestione efficiente della posta elettronica con intelligenza artificiale vocale e sui dispositivi",
        "learn": "Scopri come utilizzare i comandi vocali e le attività intelligenti per gestire la tua casella di posta in modo efficiente, mantenendo al sicuro i tuoi dati.",
        "tryOpen": {
            "title": "Prova a dire `Apri Outlook` o `Apri Gmail`",
            "description": "Assicurati che il microfono sia acceso e pronuncia \"Apri Outlook\" o \"Apri Gmail\". Verrà aperta l'app di posta elettronica scelta. Se hai attivato il cambio automatico dei controlli, verranno utilizzati anche i controlli più adatti all'app che stai utilizzando."
        },
        "select": {
            "title": "Seleziona un'e-mail",
            "description": "Fai clic su un'e-mail. Quindi, prova a dire \"Seleziona e-mail\". In questo modo verrà selezionata l'e-mail evidenziata."
        },
        "delete": {
            "title": "Elimina un'e-mail",
            "description": "Prova a dire \"Elimina\". In questo modo eliminerai l'email selezionata."
        },
        "reply": {
            "title": "Rispondi a un'e-mail",
            "description": "Fai clic su un'e-mail. Quindi, prova a dire \"Rispondi\". Si aprirà la finestra di risposta per l'e-mail evidenziata."
        },
        "dictateIntro": {
            "title": "Detta la tua risposta",
            "description": "Puoi usare la dettatura per scrivere la tua risposta senza usare le mani. Assicurati che il microfono sia acceso e che la modalità dettatura sia attivata."
        },
        "dictateReply": {
            "title": "Inizia a rispondere",
            "description": "Prova a scrivere \"Sono interessato a saperne di più sui vostri servizi. Vi prego di inviarmi ulteriori informazioni\". In questo modo, la tua risposta verrà scritta nell'e-mail. Assicurati di concentrarti sulla casella di testo della risposta."
        },
        "newEmail": {
            "title": "Crea una nuova email",
            "description": "Prova a dire \"Nuova email\". Si aprirà una nuova finestra per la composizione di un'email."
        },
        "customEmailTemplates": {
            "title": "Modelli di posta elettronica personalizzati",
            "description": "Puoi creare modelli di email personalizzati per le risposte più comuni. Questo ti permetterà di inserire rapidamente contenuti preimpostati nelle tue email utilizzando comandi vocali o azioni rapide."
        },
        "editAppControls": {
            "title": "Modifica controlli app",
            "description": "Per creare un modello di email personalizzato, fare clic sul pulsante Modifica controlli app."
        },
        "addNewControl": {
            "title": "Aggiungi nuovo controllo",
            "description": "Nell'editor App Controls, fare clic sul pulsante Aggiungi nuovo controllo."
        },
        "quickAction": {
            "title": "Seleziona Azione rapida",
            "description": "Selezionare Azione rapida come tipo di controllo."
        },
        "templateName": {
            "title": "Assegna un nome al tuo modello",
            "description": "Assegna un nome al tuo modello di posta elettronica personalizzato, ad esempio \"Richiesta di riunione\"."
        },
        "eventType": {
            "title": "Seleziona il tipo di evento",
            "description": "Nella sezione Tipo di evento, seleziona \"tipo\" come tipo di evento."
        },
        "typeSteps": {
            "title": "Tipo Modello Contenuto",
            "description": "Digita il contenuto del tuo modello di email. Ad esempio, puoi inserire: \"Lead Outreach\nBuongiorno, vorrei fissare un incontro per discutere di potenziali opportunità di collaborazione. Per favore, fammi sapere se sei disponibile.\""
        },
        "finish": {
            "title": "Completa la creazione del modello",
            "description": "Fare clic sul pulsante Fine per completare la creazione del modello di posta elettronica personalizzato."
        },
        "saveTemplate": {
            "title": "Salva il tuo modello",
            "description": "Fare clic sul pulsante Salva per salvare il modello di posta elettronica personalizzato."
        },
        "focusApp": {
            "title": "Riconcentrati sulla tua app di posta elettronica",
            "description": "Torna alla tua app di posta elettronica e assicurati di concentrarti sulla nuova riga dell'oggetto dell'email."
        },
        "useTemplate": {
            "title": "Usa il tuo modello",
            "description": "Ora puoi utilizzare il tuo modello di email personalizzato pronunciandone il nome o cliccando sul pulsante Azione rapida."
        },
        "generateIntro": {
            "title": "Genera contenuto e-mail",
            "description": "Puoi anche utilizzare Cephable Intelligent Generate per creare contenuti email direttamente nella tua app di posta elettronica. Tutto questo avviene direttamente sul dispositivo, il che significa che i tuoi dati rimangono privati e al sicuro."
        },
        "enterPrompt": {
            "title": "Inserisci richiesta e-mail",
            "description": "Nella casella di richiesta, digita: Scrivi un'e-mail professionale a un potenziale cliente presentando i nostri servizi e richiedendo un incontro."
        },
        "focusNewEmail": {
            "title": "Concentrati sulla nuova email",
            "description": "Assicurati di concentrarti sulla nuova finestra di composizione dell'e-mail in cui desideri che venga visualizzato il testo generato."
        },
        "translateEmail": {
            "title": "Traduci il contenuto dell'email",
            "description": "Puoi utilizzare Cephable Intelligent Translate per tradurre il contenuto delle email direttamente nella tua app di posta elettronica. Tutto questo avviene direttamente sul dispositivo, il che significa che i tuoi dati rimangono privati e al sicuro."
        },
        "highlightText": {
            "title": "Evidenzia il contenuto dell'email",
            "description": "Evidenzia il contenuto di un'e-mail lunga che vuoi tradurre."
        },
        "enterLanguage": {
            "title": "Inserisci la lingua della traduzione",
            "description": "Digita la lingua della traduzione. Ad esempio, puoi inserire: \"Spagnolo\"."
        },
        "complete": {
            "description": "Ora sai come utilizzare i comandi vocali e le Attività Intelligenti per navigare, rispondere, dettare, generare e tradurre email mantenendo al sicuro i tuoi dati. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per una gestione delle email ancora più fluida."
        }
    },
    "handsFreeMeeting": {
        "tourLabel": "Controlli rapidi per riunioni a mani libere",
        "learn": "Risparmia tempo e riduci l'affaticamento delle riunioni virtuali con i controlli rapidi delle riunioni a mani libere",
        "tryOpen": {
            "title": "Prova a dire `Apri Zoom` o `Apri Teams`",
            "description": "Assicurati che il microfono sia acceso e pronuncia \"Apri Zoom\" o \"Apri Teams\". Verrà aperta l'app per riunioni scelta. Se hai attivato il cambio automatico dei controlli, verranno utilizzati anche i controlli più adatti all'app che stai utilizzando."
        },
        "mute": {
            "title": "Prova a dire `Attiva/Disattiva audio` per disattivare il microfono",
            "description": "Assicurati che il microfono sia acceso e pronuncia \"Attiva/Disattiva audio\". In questo modo il microfono verrà disattivato nell'app per riunioni scelta."
        },
        "video": {
            "title": "Prova a dire \"Attiva/disattiva video\" per accendere o spegnere la videocamera",
            "description": "Assicurati che il microfono sia acceso e pronuncia \"Attiva/disattiva video\". In questo modo la videocamera verrà attivata o disattivata nell'app per riunioni scelta."
        },
        "raiseHand": {
            "title": "Prova a dire `Alza la mano` per alzare la mano",
            "description": "Assicurati che il microfono sia acceso e pronuncia \"Alza la mano\". In questo modo alzerai la mano nell'app per riunioni che hai scelto."
        },
        "quickType": {
            "title": "Digitazione rapida",
            "description": "Assicurati che il microfono sia acceso e pronuncia \"Digitare è una funzione fantastica\". Questo ti permetterà di digitare rapidamente usando la voce senza essere in modalità dettatura. Assicurati di essere concentrato su un campo di testo nell'app per le riunioni."
        },
        "complete": {
            "description": "Ora sai come utilizzare i comandi vocali e le azioni rapide per disattivare/riattivare l'audio, attivare/disattivare il video, alzare la mano e digitare rapidamente nelle tue app per riunioni preferite. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un controllo ancora più fluido della riunione."
        }
    },
    "summarizingReports": {
        "tourLabel": "Riepiloga report e documenti con l'intelligenza artificiale sul dispositivo",
        "learn": "Scopri come utilizzare la sintesi basata sull'intelligenza artificiale per ottenere rapidamente i punti chiave da lunghi report e documenti, mantenendo al sicuro i tuoi dati riservati e proprietari.",
        "summarizeIntro": {
            "title": "Riassumi il testo",
            "description": "Puoi utilizzare Cephable Intelligent Tasks per ottenere rapidamente i punti chiave da report e documenti lunghi. Summarize fa parte delle On-device AI Tasks, il che significa che funziona senza connessione a Internet ed è eseguibile dal tuo dispositivo."
        },
        "navigateToReport": {
            "title": "Concentrati sul tuo report o documento",
            "description": "Apri il tuo report o documento nell'app che preferisci e concentrati sul testo che vuoi riassumere."
        },
        "highlightText": {
            "title": "Evidenzia il testo per riassumere",
            "description": "Evidenzia il testo che vuoi riassumere."
        },
        "copyText": {
            "title": "Copia il testo",
            "description": "Dopo aver evidenziato il testo, copialo per prepararlo alla sintesi."
        },
        "enterPrompt": {
            "title": "Inserisci le istruzioni di riepilogo",
            "description": "Digita le istruzioni per il riepilogo. Specifica la lunghezza, lo stile o qualsiasi altro contenuto specifico desideri."
        },
        "pasteText": {
            "title": "Incolla il contenuto del tuo report",
            "description": "Dopo le istruzioni, incolla il testo copiato nella casella di input."
        },
        "focusChatApp": {
            "title": "Concentrati sulla tua app di chat",
            "description": "Apri la tua app di chat, come Teams o Slack, e concentrati sulla casella di testo in cui desideri che venga visualizzato il testo riassuntivo."
        },
        "rewriteIntro": {
            "title": "Riscrivi il testo riassuntivo",
            "description": "Puoi anche utilizzare Cephable Intelligent Rewrite per perfezionare ulteriormente il testo riassuntivo. Tutto questo avviene direttamente sul dispositivo, il che significa che i tuoi dati rimangono privati e al sicuro."
        },
        "highlightSummary": {
            "title": "Evidenzia il testo riassunto",
            "description": "Evidenzia il testo riassuntivo che vuoi ulteriormente perfezionare."
        },
        "enterRewriteInstructions": {
            "title": "Inserisci le istruzioni di riscrittura",
            "description": "Digita le istruzioni per la riscrittura. Specifica il tono, lo stile o eventuali modifiche specifiche che desideri."
        },
        "complete": {
            "description": "Hai imparato a utilizzare le Attività Intelligenti per una sintesi testuale rapida e sicura, utile per condividere i risultati con il tuo team. Continua a esplorare altri casi d'uso con Riepiloga e Riscrivi, o altre funzionalità per ottimizzare il tuo flusso di lavoro."
        }
    },
    "congrats": "Congratulazioni!",
    "noteTakingAndDocumentation": {
        "tourLabel": "Prendere appunti e generare documenti utilizzando l'intelligenza artificiale privata sul dispositivo",
        "learn": "Scopri come utilizzare i comandi vocali, la dettatura intelligente e le attività basate sull'intelligenza artificiale per passare più velocemente dagli appunti ai progetti e ai documenti.",
        "focus": {
            "title": "Concentrarsi su un campo di testo o un documento",
            "description": "La dettatura funziona meglio quando ci si concentra su un campo di testo o un documento. Apri un documento o fai clic su un campo di testo in cui desideri prendere appunti."
        },
        "speaking": {
            "title": "Inizia a parlare",
            "description": "Ora puoi iniziare a parlare. Mentre rifletti sulla tua idea, parla in modo naturale e lascia fluire i tuoi pensieri. Tutto ciò che dirai verrà digitato nel campo di testo o nel documento su cui ti sei concentrato. Prova a descrivere il tuo concept, a delineare i passaggi o a fare brainstorming liberamente. Ad esempio, di': \"Sto valutando un nuovo flusso di lavoro per il nostro team. Per prima cosa, dovremmo automatizzare il processo di reporting, quindi rivedere i risultati settimanalmente\". Assicurati che il cursore sia posizionato sul documento."
        },
        "typeEnter": {
            "title": "Interruzioni di paragrafo",
            "description": "Per creare interruzioni di paragrafo, basta premere Invio sulla tastiera. Questo ti aiuterà a organizzare i tuoi appunti in sezioni chiare. Continua a esprimere i tuoi pensieri o a trascrivere ciò che sta parlando qualcun altro."
        },
        "rewriteIntro": {
            "title": "Crea progetti",
            "description": "Ora puoi usare Cephable Intelligent Rewrite per prendere appunti e trasformarli in un'idea per una funzionalità o in azioni di follow-up. Tutto questo avviene direttamente sul dispositivo, il che significa che i tuoi dati rimangono privati e al sicuro."
        },
        "highlightText": {
            "title": "Evidenzia le note",
            "description": "Seleziona tutte le note che vuoi utilizzare per creare un progetto o un documento."
        },
        "inPlaceReplacement": {
            "title": "Ideazione sul posto",
            "description": "Ora useremo la sostituzione sul posto per trasformare le tue note in un progetto o in un documento. Puoi sempre usare la modalità Incolla o l'opzione per creare un nuovo file."
        },
        "enterInstructions": {
            "title": "Inserisci le istruzioni di progettazione",
            "description": "Puoi scrivere le istruzioni per i passaggi successivi, specificando cosa vorresti fare con le note. Potrebbe trattarsi di formattazione, progettazione, attività di follow-up o qualsiasi altra cosa. (Ad esempio, crea un documento di progettazione che evidenzi il funzionamento della funzionalità, l'aspetto finale e le possibili conseguenze per il successo)."
        },
        "complete": {
            "description": "Hai imparato a utilizzare i comandi vocali e la dettatura intelligente per documentare le note cliniche, e la riscrittura intelligente per formattarle in stile SOAP. Continua a esplorare altri casi d'uso con la dettatura e la riscrittura, o altre funzionalità per ottimizzare il tuo flusso di lavoro."
        }
    },
    "fpsGamePlay": {
        "tourLabel": "Gioca ai giochi FPS con i comandi vocali",
        "learn": "Scopri come usare i comandi vocali e le azioni rapide per giocare ai giochi FPS.",
        "changeProfile": {
            "title": "Profilo di controllo delle modifiche",
            "description": "Imposta il controllo dell'app sul profilo di gioco FPS. Puoi personalizzarlo anche per il gioco specifico a cui vuoi giocare. Guarda il video."
        },
        "autoProfileSwitching": {
            "title": "Disattivare la commutazione del controllo automatico",
            "description": "In questo modo il controllo delle app correnti rimarrà attivo finché non cambierai app."
        },
        "tryOpen": {
            "title": "Prova a dire `Apri Valorant` o `Apri Battlefield`"
        },
        "go": {
            "title": "Prova a dire \"Vai\"",
            "description": "Assicurati che il microfono sia acceso e pronuncia il comando \"Vai\". Il tuo personaggio inizierà a muoversi in avanti."
        },
        "stop": {
            "title": "Prova a dire `Stop`",
            "description": "Assicurati che il microfono sia acceso e pronuncia `Stop`. Questo fermerà il movimento del tuo personaggio."
        },
        "complete": {
            "description": "Ora sai come usare i comandi vocali e le azioni rapide per muoverti, fermarti e controllare il tuo personaggio nei giochi FPS. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un gameplay ancora più fluido e veloce."
        }
    },
    "presentationControls": {
        "tourLabel": "Controlla le presentazioni con i comandi vocali",
        "learn": "Scopri come utilizzare i comandi vocali e le azioni rapide per navigare e controllare le tue presentazioni senza usare le mani.",
        "tryOpen": {
            "title": "Prova a dire `Apri PowerPoint` o `Apri Google Slides`"
        },
        "startPresentation": {
            "title": "Prova a dire `Avvia presentazione` per iniziare la presentazione",
            "description": "Assicurati che il microfono sia acceso e pronuncia `Avvia presentazione`. In questo modo la presentazione verrà avviata nell'app di presentazione scelta."
        },
        "nextSlide": {
            "title": "Prova a dire `Diapositiva successiva` per passare alla diapositiva successiva",
            "description": "Assicurati che il microfono sia acceso e pronuncia \"Diapositiva successiva\". In questo modo passerai alla diapositiva successiva della presentazione."
        },
        "previousSlide": {
            "title": "Prova a dire `Diapositiva precedente` per tornare alla diapositiva precedente",
            "description": "Assicurati che il microfono sia acceso e pronuncia \"Diapositiva precedente\". In questo modo tornerai alla diapositiva precedente della presentazione."
        },
        "escape": {
            "title": "Prova a dire `Esc` per uscire dalla modalità presentazione",
            "description": "Assicurati che il microfono sia acceso e pronuncia `Esc`. Questo uscirà dalla modalità presentazione nell'app di presentazione scelta."
        },
        "complete": {
            "description": "Ora sai come utilizzare i comandi vocali e le azioni rapide per avviare, navigare e uscire dalle presentazioni senza usare le mani. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un controllo ancora più fluido della presentazione."
        }
    },
    "editingImages": {
        "tourLabel": "Modifica delle immagini più rapida con comandi vocali e dettatura",
        "learn": "Scopri come utilizzare i comandi vocali, le azioni rapide e la dettatura per migliorare il processo di modifica delle immagini.",
        "tryOpen": {
            "title": "Prova a dire `Apri Figma` o `Apri Photoshop`"
        },
        "selectAll": {
            "title": "Prova a dire `Seleziona tutto` per selezionare tutti gli elementi sulla tela",
            "description": "Assicurati che il microfono sia acceso e pronuncia \"Seleziona tutto\". In questo modo verranno selezionati tutti gli elementi sulla tela nell'app di editing immagini scelta. Assicurati di essere concentrato sull'app."
        },
        "bold": {
            "title": "Prova a dire `Grassetto` per rendere in grassetto il testo selezionato",
            "description": "Assicurati che il microfono sia acceso e pronuncia \"Grassetto\". Questo applicherà il grassetto al testo selezionato nell'app di editing immagini scelta. Assicurati di aver selezionato il testo."
        },
        "copy": {
            "title": "Prova a dire `Copia` per copiare l'elemento selezionato",
            "description": "Assicurati che il microfono sia acceso e pronuncia \"Copia\". In questo modo, l'elemento selezionato verrà copiato nell'app di modifica delle immagini scelta. Assicurati di aver selezionato un elemento."
        },
        "paste": {
            "title": "Prova a dire `Incolla` per incollare l'elemento copiato",
            "description": "Assicurati che il microfono sia acceso e pronuncia `Incolla`. Questo incollerà l'elemento copiato nell'app di modifica delle immagini scelta."
        },
        "delete": {
            "title": "Prova a dire `Elimina` per eliminare l'elemento selezionato",
            "description": "Assicurati che il microfono sia acceso e pronuncia \"Elimina\". Questo eliminerà l'elemento selezionato nell'app di modifica delle immagini scelta. Assicurati di aver selezionato un elemento."
        },
        "dictationIntro": {
            "title": "Dettatura",
            "description": "Puoi usare la dettatura per digitare testo usando la voce. Assicurati che il microfono sia acceso e che la modalità dettatura sia attivata."
        },
        "focus": {
            "title": "Concentrati su un campo di testo",
            "description": "Fai clic su un campo di testo nell'app di modifica delle immagini in cui desideri utilizzare la dettatura."
        },
        "speaking": {
            "title": "Inizia a parlare",
            "description": "Prova a dire \"Per ottenere codici sconto anticipati, scansiona il codice QR. È valido fino al 30 settembre. Poi, richiedilo tramite il sito web\". Assicurati di concentrarti sul campo di testo o sull'area in cui vuoi dettare."
        },
        "complete": {
            "description": "Ora sai come utilizzare i comandi vocali, le azioni rapide e la dettatura per migliorare il tuo processo di editing delle immagini. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un editing delle immagini ancora più fluido."
        }
    },
    "redo": "Ripeti l'onboarding",
    "title": "Incontra Cephable",
    "description": "Incontra Cephable, il tuo assistente AI personale e condividi il tuo interesse per i casi d'uso personalizzati."
}
